/* eslint-disable eqeqeq */
import { toSportType } from 'nike-ui/src/common/sports';

/**
 * Created by juraj.homola on 9. 9. 2016.
 */

export default {
    sportType(sportId) {
        return toSportType(sportId);
    },
    isFinished(eventStatusCode) {
        return ['CANCELLED', 'FINISHED'].indexOf(eventStatusCode) > -1;
    },
    isBreak(eventStatusCode) {
        return eventStatusCode === 'BREAK';
    },
    isInterrupted(eventStatusCode) {
        return eventStatusCode === 'INTERRUPTED';
    },
    isRainDelay(eventExtraInfo) {
        return eventExtraInfo === 'RAIN_DELAY';
    },
    showTime(sportId) {
        let showTimeSports = ['futbal', 'hokej', 'hadzana', 'basketbal', 'americkyfutbal', 'futsal', 'rugby'];
        return showTimeSports.indexOf(toSportType(sportId)) > -1;
    },
    showTimeInBreak(sportId) {
        let showTimeInBreakSports = ['futbal', 'hokej', 'hadzana', 'basketbal', 'rugby'];
        return showTimeInBreakSports.indexOf(toSportType(sportId)) > -1;
    },

    toMinutes(time) {
        let minute = Math.floor(time / 60);
        return minute < 10 ? '0' + minute : minute;
    },
    toSeconds(time) {
        let second = time % 60;
        return second < 10 ? '0' + second : second;
    },
    defaultScore(score) {
        return !!score && score != '-' && score != '00' ? score : '0';
    }
};
